import { FocusEvent } from "react";

import { useLiveFormEditorContext } from "../common/LiveFormEditorContext";

import { useScrollPreviewWithArrow } from "./useScrollPreviewWithArrow";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- the preview arrow targets an element rendered by the canvas
import { COMMUNICATION_PREFERENCES_FIELD_ID } from "@/canvas/features/FormV2/blocks/payment/CommunicationPreferences/CommunicationPreferencesFieldContainer";
import { useArrow } from "@/components/LiveEditorElements/AnimatePreview/Arrow/ArrowContext";
import { COMMUNICATION_PREFERENCES_QUESTION_KEY } from "@/features/LiveFormEditor/Steps/StepQuestionsV4/types";

// Lets the preview render the newly saved field first.
const ADDED_ANIMATION_DELAY_MS = 300;

export const useAnimatePreviewOnCommunicationPreferences = () => {
  const { setPreviewStepKey } = useLiveFormEditorContext();
  const { hideArrow } = useArrow();
  const { scrollAndUpdateArrow } = useScrollPreviewWithArrow();

  const focusCommunicationPreferences = () => {
    hideArrow();
    setPreviewStepKey("payment");
    scrollAndUpdateArrow({ targetElementId: COMMUNICATION_PREFERENCES_FIELD_ID });
  };

  const focusAddedCommunicationPreferences = () => {
    window.setTimeout(focusCommunicationPreferences, ADDED_ANIMATION_DELAY_MS);
  };

  const handleQuestionsFocus = (event: FocusEvent<HTMLElement>) => {
    if ((event.target as HTMLElement).closest(`[data-question-key="${COMMUNICATION_PREFERENCES_QUESTION_KEY}"]`)) {
      focusCommunicationPreferences();
    }
  };

  return { focusCommunicationPreferences, focusAddedCommunicationPreferences, handleQuestionsFocus, hideArrow };
};
